module.exports = __webpack_public_path__ + "static/media/marcas (2).9255b50f.png";